import { Grid, styled } from '@mui/material';
import { OutlinedDropdown, PrimaryButton, RoundedDialog, SecondaryButton, Text } from 'library';
import React, { useState } from 'react';
import { useUserContext } from 'UserContext';

interface IAddressSelectModalProps {
    isOpen: boolean;
    onAddressSelect: (id: string) => void;
    onClose: () => void;
}

export default function AddressSelectModal({ isOpen, onAddressSelect, onClose }: IAddressSelectModalProps) {
    const [selectedAddress, setSelectedAddress] = useState('');

    const { user } = useUserContext();
    const userAddresses = user?.address;

    function onSelectClick() {
        onAddressSelect(selectedAddress);
        setSelectedAddress('');
    }

    return (
        <RoundedDialog open={isOpen} onClose={onClose} style={{ padding: 20 }}>
            <Grid container direction="column">
                <Text variant="h2" textStyle={{ marginBottom: 10 }}>
                    Select the location this is for
                </Text>
                <OutlinedDropdown
                    textLabel="Location"
                    value={selectedAddress || ''}
                    fields={
                        userAddresses?.map((b) => {
                            return { key: b.id.toString(), value: b.business_location?.name || '' };
                        }) || []
                    }
                    onChange={(e) => setSelectedAddress(e.target.value)}
                />
                <ButtonContainer container justifyContent="space-around">
                    <SecondaryButton onClick={onClose} buttonStyle={{ width: 'fit-content' }}>
                        Cancel
                    </SecondaryButton>
                    <PrimaryButton onClick={onSelectClick} buttonStyle={{ width: 'fit-content' }}>
                        Select
                    </PrimaryButton>
                </ButtonContainer>
            </Grid>
        </RoundedDialog>
    );
}

const ButtonContainer = styled(Grid)({
    marginTop: 15,
});
